import { jsx as f } from "react/jsx-runtime";
import { useRef as g } from "react";
import { useMountedState as m, useMount as u, useUpdateEffect as B } from "react-use";
import { styled as h, Box as k } from "@mui/material";
const p = (o = 25) => {
  const e = g(null), t = m(), l = () => {
    const r = e.current;
    return r ? r.scrollHeight - r.scrollTop <= r.clientHeight + o : !1;
  }, c = () => {
    const r = e.current;
    r && l() && (r.scrollTop = r.scrollHeight);
  };
  return u(c), u(() => {
    if (!e.current)
      return;
    const r = new MutationObserver(() => {
      t() && c();
    });
    return r.observe(e.current, {
      childList: !0,
      subtree: !0,
      characterData: !0
    }), () => {
      r.disconnect();
    };
  }), {
    containerRef: e,
    scrollToBottom: c
  };
}, v = h(k, {
  shouldForwardProp: (o) => !["variant"].includes(o)
})(({ variant: o = "default" }) => {
  const t = {
    default: {
      trackBg: "rgba(0, 0, 0, 0.05)",
      thumbBg: "rgba(0, 0, 0, 0.2)",
      thumbHoverBg: "rgba(0, 0, 0, 0.3)"
    },
    dark: {
      trackBg: "#2d2d2d",
      thumbBg: "#666",
      thumbHoverBg: "#888"
    },
    colorful: {
      trackBg: "#f1f1f1",
      thumbBg: "#888",
      thumbHoverBg: "#555"
    }
  }[o];
  return {
    overflowY: "auto",
    position: "relative",
    scrollBehavior: "smooth",
    // Webkit browsers (Chrome, Safari, Edge)
    "&::-webkit-scrollbar": {
      width: "8px",
      background: "transparent"
    },
    "&::-webkit-scrollbar-track": {
      background: t.trackBg,
      borderRadius: "4px"
    },
    "&::-webkit-scrollbar-thumb": {
      background: t.thumbBg,
      borderRadius: "4px",
      "&:hover": {
        background: t.thumbHoverBg
      }
    },
    // Firefox
    scrollbarWidth: "thin",
    scrollbarColor: `${t.thumbBg} ${t.trackBg}`
  };
}), y = ({
  children: o,
  height: e = "auto",
  maxHeight: t,
  minHeight: l = "auto",
  width: c = "auto",
  maxWidth: r = "auto",
  minWidth: s = "auto",
  className: n = void 0,
  threshold: a = 25,
  variant: i = "default"
}) => {
  const { containerRef: b, scrollToBottom: d } = p(a);
  return B(d, [o]), /* @__PURE__ */ f(
    v,
    {
      ref: b,
      className: n,
      variant: i,
      sx: {
        height: e,
        maxHeight: t,
        minHeight: l,
        width: c,
        maxWidth: r,
        minWidth: s
      },
      children: o
    }
  );
};
export {
  y as A
};
